/* external imports */
import { h, Fragment, Component } from 'preact';
import { observer } from 'mobx-react';

/* searchspring imports */
import { withController, useMediaQuery } from '@searchspring/snap-preact-components';

/* local styles */
import './Tabs.css'

export const Tabs = withController(
	observer((props) => {
		const { controller, tabs, inAc } = props;
		const store = controller.store;
		const page  = store.config.plugins[1];

		const activeTab = tabs.active.id;

		// filter tabs that have no product count
		let filteredTabs = tabs.options.filter((tab) => {
			return tab.controller.store.pagination.totalResults !== 0;
		});

		// determine whether to show tabs or not
		const showTabs = inAc || (!inAc && page.type != 'collection' && page.type != 'landing-page');
		const isMobile = useMediaQuery('(max-width: 749px)');

		return (
			showTabs &&
			filteredTabs.length > 0 && (
				<div className="ss__tabs">
					<div className="ss__tabs__row ss__flex--wrap ss__flex--center-align">
						{tabs.options.map((tab) => {
							return (
								<div className={`ss__tabs__column ss__tabs__column--button ss__tab-mobile--${tab.id}${tab.id == activeTab ? ' ss__tab--mobile-active' : ''}`}>
									<button
										key={tab.id}
										type="button"
										className={`ss__tab ss__tab--button ss__tab--${tab.id}${tab.id == activeTab ? ' ss__tab--active' : ''}`}
										onClick={() => {
											tabs.switch(tab.id);
											if (inAc) {
												// set a delay on autocomplete to avoid flash of no results
												store.custom.swapped = true;
												setTimeout(() => {
													tabs.active.controller.store.custom.swapped = false;
													tabs.switch(tab.id);
												}, 500);
											} else {
												tabs.switch(tab.id);
											}
										}}
									>

									{inAc == true && 
										<>
											{tab.label}
										</>
									}

									{!inAc &&
										<>
											{tab.labelPage}
										</>
									}

									{/*!inAc ? `(${tab.controller.store.pagination.totalResults ? tab.controller.store.pagination.totalResults : 0 })` : null*/}
									</button>
								</div>
							);
						})}
					</div>
				</div>
			)
		);
	})
);